// 3rd-party
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  IconButton,
  Button,
  Alert,
  TextField,
} from "@mui/material";

// Asset components
import cross from "../../assets/close-circle.svg";
import visiable from "../../assets/visiable.svg";
import edit from "../../assets/edit.svg";
import delete1 from "../../assets/delete.svg";
import add from "../../assets/add.svg";

// Config
import { appConfig } from "../../config/appConfig";

// Services
import { removeImageByIndex } from "../../services/IndiaService";

// Styles
import "./ImageGalleryDialog.scss";
import { UPLOADTYPE } from "../../models/enums/globalEnums";

interface ImageGalleryDialogProps {
  open: boolean;
  onClose: () => void;

  oldMedia?: any;
  setOldMedia?: any;
  oldThumbnail?: any;
  setOldThumbnail?: any;
  gridType?: any;
  setGridType?: any;
  newMedia?: any;
  setNewMedia?: any;
  newThumbnail?: any;
  setNewThumbnail?: any;
  setgridTitle?: any;
  gridTitle?: any;
  editingIndex?: any;
}

const ImageGalleryDialog: React.FC<ImageGalleryDialogProps> = ({
  open,
  onClose,
  oldMedia,
  setOldMedia,
  oldThumbnail,
  setOldThumbnail,
  gridType,
  setGridType,
  newMedia,
  setNewMedia,
  newThumbnail,
  setNewThumbnail,
  setgridTitle,
  gridTitle,
  editingIndex,
}) => {
  const [gridImages, setgridImages] = useState<string>("");
  const [gridThumbnail, setgridThumbnail] = useState<string>("");

  const [selectedThumbnail, setSelectedThumbnail] = useState<File[]>([]);
  const [selectedImages, setSelectedImages] = useState<File[]>([]);
  const [selectgridtitle, setselectgridtitle] = useState<string>("");

  const [error, setError] = useState<string | null>(null);
  const [imagepreview, setimagepreview] = useState<string | null>(null);
  const [thumbnailpreview, setthumbnailpreview] =
    useState<string>("No Thumbnail");

  const images =
    typeof gridImages === "string"
      ? gridImages
        .split(",")
        .map((img) => img.trim())
        .filter(Boolean)
      : [];

  const MAX_FILE_SIZE_MB = 2;
  const MAX_FILE_SIZE_MB1 = 100;
  const ALLOWED_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "video/mp4",
    "application/pdf",
  ];
  const ALLOWED_TYPE = ["image/jpeg", "image/jpg", "image/png"];
  const MAX_pdfFILE_SIZE_MB = 15;
  const ALLOWED_pdfTYPE = "application/pdf";
  useEffect(() => {
    if (oldMedia) {
      setgridImages(oldMedia);
    }
    if (oldThumbnail) {
      setthumbnailpreview(
        `${appConfig.serviceUrls.commonURL}${oldThumbnail.trim()}`,
      );

      setgridThumbnail(oldThumbnail);
      if (!newThumbnail) setthumbnailpreview(oldThumbnail);
    }
    if (gridTitle) {
      setselectgridtitle(gridTitle);
    }
    if (newMedia) {
      setSelectedImages(Array.isArray(newMedia) ? newMedia : []);
    }
    if (newThumbnail) {
      if (Array.isArray(newThumbnail)) {
        setSelectedThumbnail(newThumbnail);
        if (newThumbnail.length > 0) {
          setthumbnailpreview(URL.createObjectURL(newThumbnail[0]));
        }
      } else {
        setSelectedThumbnail([]);
      }
    }
    if (newThumbnail instanceof File || newThumbnail instanceof Blob) {
      setthumbnailpreview(URL.createObjectURL(newThumbnail));
    }
  }, [oldMedia, oldThumbnail, gridTitle, newMedia, newThumbnail]);

  const handleClose = () => {
    onClose();
    setgridThumbnail("");
    setgridImages("");
    setSelectedThumbnail([]);
    setSelectedImages([]);
    setselectgridtitle("");
  };

  const handleAdd = () => {
    setOldMedia(gridImages);
    setGridType(UPLOADTYPE.IMAGES);
    setOldThumbnail(gridThumbnail);

    setNewMedia(selectedImages);
    setNewThumbnail(selectedThumbnail);
    setgridTitle(selectgridtitle);

    handleClose();
  };

  const handleRemoveImage = (imgIndex: number) => {
    const updatedImageUrls = removeImageByIndex(gridImages, imgIndex);

    setgridImages(updatedImageUrls.join(","));
  };
  const handleRemoveALL = () => {
    setgridImages("");
    setgridThumbnail("");

    setSelectedThumbnail([]);
    setSelectedImages([]);

    setError(null);
    setimagepreview("");
  };

  const handlePreview = (img: string) => {
    // alert(img);
    if (img.toLowerCase().includes(".pdf")) {
      window.open(img, "_blank"); // open PDF in new tab
    } else {
      setimagepreview(img);
    }
  };
  const handleThumbnailUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) return;

    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    if (fileExtension === "jfif") {
      setError(`Thumbnail type .jfif is not allowed: ${file.name}`);
      return;
    }

    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      setError(`Thumbnail size of ${file.name} must be ≤ 2MB.`);
      return;
    }
    setError(null);
    setSelectedThumbnail([file]);
    setthumbnailpreview(URL.createObjectURL(file));
  };

  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setError(null);
    const files = e.target.files;

    if (!files || files.length === 0) {
      setError("Please select valid image(s).");
      return;
    }

    const filesArray = Array.from(files);

    for (const file of filesArray) {
      // Check for disallowed jfif type
      const fileExtension = file.name.split(".").pop()?.toLowerCase();
      if (fileExtension === "jfif") {
        setError(`File type .jfif is not allowed: ${file.name}`);
        return;
      }
      if (!ALLOWED_TYPES.includes(file.type)) {
        setError(`Invalid file type: ${file.name}`);
        return;
      }
      if (
        file.type === "video/mp4" &&
        file.size > MAX_FILE_SIZE_MB1 * 1024 * 1024
      ) {
        setError("Video size must be less than or equal to 100MB.");
        return;
      } else if (
        ALLOWED_TYPE.includes(file.type) &&
        file.size > MAX_FILE_SIZE_MB * 1024 * 1024
      ) {
        setError(`Image size of ${file.name} must be ≤ 2MB.`);
        return;
      } else if (
        file.type == ALLOWED_pdfTYPE &&
        file.size > MAX_pdfFILE_SIZE_MB * 1024 * 1024
      ) {
        setError("File size must be less than or equal to 10MB.");
        return;
      }
    }
    const previmgcnt = images.length;
    const newimgcnt = selectedImages.length;
    const currimgcnt = filesArray.length;
    if (previmgcnt + newimgcnt + currimgcnt > 18) {
      setError("Images/Video/Pdf should not be more than 18");
      return;
    }
    setError(null);
    setSelectedImages((prevImages) => [...prevImages, ...filesArray]); // directly update state here
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setselectgridtitle(e.target.value);
  };
  return (
    <Dialog
      open={open}
      maxWidth={false}
      fullWidth
      onClose={onClose}
      PaperProps={{
        sx: {
          width: "95vw",
          height: "95vh",
          maxWidth: "95vw",
          maxHeight: "95vh",
          overflow: "hidden", // prevent scrollbars on Dialog itself
          backgroundColor: "#fff",
        },
      }}
    >
      <DialogContent
        className="body1"
        sx={{
          padding: "0px", // remove default padding to control layout fully via CSS
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* HEADER */}
        <Box className="header1">
          <Typography className="header-text">
            <b>Story Gallery</b>
          </Typography>
          <IconButton onClick={handleClose} className="close-icon">
            {/* <CloseIcon /> */}
            <img src={cross} alt="visible" className="custom-icon2" />
          </IconButton>
        </Box>

        {/* BODY */}
        <Box
          className="content-wrapper"
          sx={{
            display: "flex",
            gap: "20px",
            padding: "20px",
            flex: 1,
            overflow: "auto",
            boxSizing: "border-box",
          }}
        >
          {/* syn name space */}
          <Box>
            <Box sx={{ marginLeft: "40px" }}>
              <Typography sx={{ paddingLeft: "10px" }}>
                <b>Name</b>
              </Typography>
              <TextField
                name="gridtitle1"
                value={selectgridtitle}
                onChange={handleChange}
                multiline
                className="custom-select"
              />
              <Typography className="pdf-name-count12 ">
                {selectgridtitle?.length || 0}/40
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "20px",
                padding: "10px",
                flex: 1,
                overflow: "auto",
                boxSizing: "border-box",
              }}
            >
              {/* LEFT PANEL */}
              <Box className="left-panel">
                <Box className="thumbnail-frame">
                  {selectedThumbnail.length > 0 ? (
                    <img
                      loading="lazy"
                      src={thumbnailpreview}
                      alt="New Thumbnail"
                      width={205}
                      height={205}
                      style={{ objectFit: "contain" }}
                    />
                  ) : gridThumbnail ? (
                    <img
                      loading="lazy"
                      src={gridThumbnail}
                      alt="Existing Thumbnail"
                      width={205}
                      height={205}
                    />
                  ) : (
                    <Typography>No thumbnail</Typography>
                  )}
                </Box>

                <Button className="edit-thumbnail" component="label">
                  <img
                    src={edit}
                    alt="edit"
                    style={{
                      width: "20px",
                      height: "20px",
                      paddingRight: "5px",
                    }}
                  />

                  <Typography className="edit-thumb-text">
                    Edit Thumbnail
                  </Typography>
                  <input
                    //   id="imageUpload"
                    type="file"
                    hidden
                    accept="image/jpeg,image/png"
                    onChange={handleThumbnailUpload}
                  />
                </Button>
                {/*  )} */}
              </Box>

              {/* CENTER PANEL */}
              <Box className="center-panel">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography className="uploaded-text">
                    <b> Uploaded Images</b>
                  </Typography>
                  <Button
                    onClick={() => handleRemoveALL()}
                    className="edit-thumbnail"
                    component="label"
                  >
                    {/* <DeleteIcon className="icon" /> */}
                    <img
                      src={delete1}
                      alt="delete"
                      style={{
                        width: "24px",
                        height: "24px",
                        paddingRight: "5px",
                      }}
                    />
                    <Typography className="edit-thumb-text">
                      Remove All
                    </Typography>
                  </Button>
                </Box>
                <Box sx={{ marginTop: "10px" }} />
                <Box className="image-list">
                  {images.map((img: any, index: any) => (
                    <Box key={index} className="image-row">
                      <Typography className="image-name">
                        {img.split("/").pop()}
                      </Typography>
                      <Box className="icon-row">
                        <img
                          onClick={
                            // () => handlePreview(`${API_image_URL}${img.trim()}`)
                            () => handlePreview(`${img.trim()}`)
                            //  handlePreview(img)
                          }
                          src={visiable}
                          alt="visiable"
                          style={{
                            width: "28px",
                            height: "28px",
                            paddingRight: "5px",
                          }}
                        />
                        <img
                          onClick={() => handleRemoveImage(index)}
                          src={delete1}
                          alt="delete"
                          style={{
                            width: "28px",
                            height: "28px",
                            paddingRight: "5px",
                          }}
                        />
                      </Box>
                    </Box>
                  ))}

                  {/* New (Selected) Images */}
                  {selectedImages.map((file: File, index: number) => (
                    <Box key={`new-${index}`} className="image-row">
                      <Typography className="image-name">
                        {file.name}
                      </Typography>
                      <Box className="icon-row">
                        <img
                          onClick={() =>
                            handlePreview(URL.createObjectURL(file))
                          }
                          src={visiable}
                          alt="visiable"
                          style={{
                            width: "28px",
                            height: "28px",
                            paddingRight: "5px",
                          }}
                        />
                        <img
                          onClick={() => {
                            const updated = [...selectedImages];
                            updated.splice(index, 1);
                            setSelectedImages(updated);
                          }}
                          src={delete1}
                          alt="delete"
                          style={{
                            width: "28px",
                            height: "28px",
                            paddingRight: "5px",
                          }}
                        />
                      </Box>
                    </Box>
                  ))}
                </Box>
                {/* {editingIndex === -1 && ( */}
                <Button className="add-button" component="label">
                  <img src={add} alt="visiable" className="img-style" />
                  <Typography>Add More</Typography>
                  <input
                    type="file"
                    hidden
                    accept="image/jpeg,image/png,video/mp4,application/pdf"
                    multiple
                    onChange={handleImageUpload}
                  />
                </Button>
                {/* )} */}

                {error && <Alert severity="error">{error}</Alert>}
              </Box>
            </Box>
          </Box>

          {/* RIGHT PANEL */}
          <Box className="right-panel">
            <Box className="preview-box">
              {imagepreview == null || imagepreview === "" ? (
                <Typography className="preview-text">Image Preview</Typography>
              ) : imagepreview?.includes(".mp4") ? (
                <video controls className="preview-video" src={imagepreview} />
              ) : imagepreview?.includes(".pdf") ? (
                <>PDF Preview</>
              ) : (
                <img
                  loading="lazy"
                  src={imagepreview}
                  alt="preview_image"
                  className="preview-image"
                />
              )}
            </Box>
            <Box className="action-buttons">
              <Button onClick={handleClose} className="cancel-button">
                Cancel
              </Button>
              {/* {editingIndex === -1 && ( */}
              <Button onClick={() => handleAdd()} className="save-button">
                Add
              </Button>
              {/* )} */}
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ImageGalleryDialog;
